import {AfterViewInit, ChangeDetectorRef, Component, Input, ViewChild} from '@angular/core';
import {AbstractVisbosComponent} from "../../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../../shared/actions";
import {ActivatedRoute, Router} from "@angular/router";
import {VbMenuEntry} from "../menu-item.interface";
import {CarouselComponent} from "ngx-bootstrap";


@Component({
  selector: 'vb-touch-menu',
  templateUrl: './touch-menu.component.html',
  styleUrls: ['./touch-menu.component.css']
})
export class TouchMenuComponent extends AbstractVisbosComponent implements AfterViewInit {

  SWIPE_ACTION = {LEFT: 'swipeleft', RIGHT: 'swiperight'};

  @Input()
  noEntriesPerPage: number = 6;

  private _menuEntries: VbMenuEntry[] = [];

  @ViewChild(CarouselComponent)
  carouselCmp: CarouselComponent;

  get menuEntries(): VbMenuEntry[] {
    return this._menuEntries;
  }

  @Input()
  set menuEntries(value: VbMenuEntry[]) {
    this._menuEntries = value;
    this.pagedMenuEntries = this.getPagedMenuEntries(this.getActiveButtons(this.menuEntries), this.noEntriesPerPage);
  }

  pagedMenuEntries: VbMenuEntry[][] = [];
  activeSlide;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private router: Router, private route: ActivatedRoute,) {
    super(sessionActions, cd);
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  getMenuEntriesForPage(page: number): VbMenuEntry[] {
    return this.pagedMenuEntries[page - 1];
  }

  getPagedMenuEntries(entries: VbMenuEntry[], noEntriesPerPage): VbMenuEntry[][] {

    const len = entries.length;
    let pages = Math.floor(len / this.noEntriesPerPage);
    if (len % this.noEntriesPerPage > 0) {
      pages += 1;
    }

    let result: VbMenuEntry[][] = [];
    for (let i = 0; i < entries.length; i += noEntriesPerPage) {
      if (result.length < pages - 1)
        result.push(entries.slice(i, i + noEntriesPerPage));
      else {
        let remaining = entries.slice(i);
        remaining.length = this.noEntriesPerPage;
        result.push(remaining);
        break;
      }
    }

    return result;
  }

  navigate(link) {
    this.router.navigate(link, {relativeTo: this.route});
  }

  setFaClass(icon: string) {
    let hasIcon: boolean = icon && icon != '';
    let c = {'fa fa-fw fa-3x': hasIcon};
    c['fa-' + icon] = hasIcon;

    return c;
  }

  getActiveButtons(entries?: VbMenuEntry[]): VbMenuEntry[] {
    entries = entries ? entries : this.menuEntries;
    return entries.filter(b => b.visible === undefined || b.visible === true);
  }

  getColClass() {
    let num = this.getActiveButtons() ? this.getActiveButtons().length : 0;
    if (num < this.noEntriesPerPage) {
      num = this.noEntriesPerPage;
    }
    if (num <= 4) {
      return "col-md-6"
    } else {
      return "col-md-4";
    }
  }

  swipe(currentIndex: number, action = this.SWIPE_ACTION.RIGHT) {
    if (action == this.SWIPE_ACTION.RIGHT) {
      this.carouselCmp.nextSlide();
    } else {
      this.carouselCmp.previousSlide();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/ui/navigation/touch-menu/touch-menu.component.ts